import {ToggleScroll} from "@main/helpers/toggle-scroll";

const TIMEOUT_HIDE_INFO_MESSAGE = 3000;

/** Компонент модала. */
export class Modal {
    isClose = false;
    /**
     * Создаёт компонент модала.
     *
     * @param {HTMLElement} el Родительский элемент модала (элемент заднего фона).
     */
    constructor(el) {
        this.el = el;
        this.bindEventListeners();
        if (this.el.classList.contains("js-mch-modal-opened")) {
            Modal.open(this.el);
        }
    }

    /**
     * Вешает колбеки закрытия модала.
     *
     * @returns {void}
     */
    bindEventListeners() {
        this.el.addEventListener("click", (e) => {
            if (
                !e.target.closest(".js-mch-modal-dialog") ||
                e.target.classList.contains("js-mch-modal-close") ||
                e.target.closest(".js-mch-modal-close")
            ) {
                Modal.close(this.el);
            }
        });
    }

    /**
     * Закрывает модал.
     *
     * @param {HTMLElement} modal Главный элемент модала.
     * @returns {void}
     */
    static close(modal) {
        modal.classList.remove("shown");
        ToggleScroll.enable(modal);
        this.isClose = true;
    }

    /**
     * Открывает модал.
     *
     * @param {Element} modal Главный элемент модала.
     * @returns {void}
     */
    static open(modal) {
        modal.classList.add("shown");
        ToggleScroll.disable(modal);

        const input = modal.querySelector("input");
        if (input) {
            input.focus();
        }

        if (modal.classList.contains("js-mch-modal-autoclose")) {
            Modal.autoclose(modal);
        }
    }

    /**
     * Закртыть модал по таймауту.
     *
     * @param {Element} modal Главный элемент модала.
     * @returns {void}
     */
    static autoclose(modal) {
        setTimeout(() => {
            if (!this.isClose) {
                Modal.close(modal);
            }
        }, TIMEOUT_HIDE_INFO_MESSAGE);
    }
}

document.querySelectorAll(".js-mch-modal").forEach((el) => new Modal(el));
